module.exports = __webpack_public_path__ + "static/img/h2-4.178a687.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/userService/h2-4.png
// module id = tTRh
// module chunks = 1